var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgChevron(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 18,
    height: 11,
    viewBox: "0 0 18 11",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.08851 0.396613C8.20091 0.275887 8.33616 0.178689 8.48643 0.110662C8.6367 0.042634 8.79898 0.00513172 8.96386 0.000331879C9.12873 -0.00446796 9.29292 0.02353 9.44689 0.0826998C9.60086 0.14187 9.74154 0.231034 9.86077 0.345017L9.91117 0.396613L17.6566 8.66877C17.8847 8.91351 18.0072 9.23827 17.9975 9.57269C17.9879 9.90711 17.8468 10.2243 17.605 10.4554C17.3733 10.6761 17.0658 10.7994 16.7458 10.7998H1.25384C1.00793 10.7974 0.768036 10.7235 0.563471 10.587C0.358904 10.4505 0.198524 10.2574 0.101927 10.0312C0.00532913 9.80504 -0.0233021 9.55565 0.0195293 9.31348C0.0623608 9.07132 0.174803 8.84687 0.343115 8.66757L8.08851 0.396613Z",
    fill: "current"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChevron);
export default __webpack_public_path__ + "static/media/chevron.78ea96b4ac31fbc5146ade289bb9fcaf.svg";
export { ForwardRef as ReactComponent };